import React from 'react';
import { useNavigationPreferences } from '../hooks/useNavigationPreferences';

interface MainContentProps {
  children: React.ReactNode;
  className?: string;
}

export const MainContent: React.FC<MainContentProps> = ({ children, className = '' }) => {
  const { preferences } = useNavigationPreferences();
  const collapsed = preferences.sidebarCollapsed;

  return (
    <main
      className={`
        min-h-screen transition-all duration-300 ease-in-out
        ml-0
        ${collapsed ? 'md:ml-16' : 'md:ml-64'}
        pb-16 md:pb-0
        bg-gray-50 dark:bg-gray-900
        ${className}
      `}
    >
      <div className="h-full">
        {children}
      </div>
    </main>
  );
};
